import { render, staticRenderFns } from "./SolucionesSection.vue?vue&type=template&id=e6a032c4&scoped=true"
import script from "./SolucionesSection.vue?vue&type=script&lang=js"
export * from "./SolucionesSection.vue?vue&type=script&lang=js"
import style0 from "./SolucionesSection.vue?vue&type=style&index=0&id=e6a032c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a032c4",
  null
  
)

export default component.exports